<script>
import CommentList from "./CommentList.vue";
import CommentInput from "./CommentInput.vue";
import {checkLoginWidthAppMessage} from "@/util/sendAppMessage";

export default {
  name: "CommentPanel",
  components: { CommentInput, CommentList },
  emits: ['refresh'],
  data() {
    return {
      show: false,
      totalCount: 0,
      item: null,
      commentList: null,
      parent_comment: null,
      userInfo: null
    }
  },
  mounted() {
    window.$bus.$on("scrollToCommentBottom", this.scrollToCommentBottom)
  },
  beforeDestroy() {
    window.$bus.$off("scrollToCommentBottom", this.scrollToCommentBottom)
  },
  methods: {
    scrollToCommentBottom() {
      document.querySelector(".van-action-sheet__content").scrollTop = 0;
    },
    showCommentPanel(item, commentList) {
      commentList = commentList || [];
      this.totalCount = commentList.length;
      this.commentList = commentList;
      this.item = item;
      this.$nextTick(() => {
        this.show = true;
      })
    },
    hideCommentPanel() {
      this.show = false;
    },
    onReply(commit) {
      this.parent_comment = commit;
      this.$refs.myInput.focus();
    },
    resetReplay() {
      this.parent_comment = null;
    },
    createComment(val) {
      let head_url = this.userInfo.head_url;
      let username = this.userInfo.username;
      let created_at = new Date().toLocaleString();
      let id = Date.now();
      let content = val;
      return { created_at, id, content, user: {head_url, username} };
    },
    async getUserInfo() {
      let userRes = await this.$axios.get("/user/getUserInfo");
      this.userInfo =  userRes.data;
    },
    onClosed() {
      this.$refs.myInput.clear();
    },
    async onSendMessage(val) {
      if(!checkLoginWidthAppMessage()) {
        return;
      }
      if(!this.userInfo) {
        await this.getUserInfo();
      }
      this.$axios.post("/shorts/addShortsComment", {
        shorts_id: this.item.id,
        shorts_comment_id: this.parent_comment ? this.parent_comment.id : undefined,
        content: val
      }).then(res => {
        if(this.parent_comment) {
          if(!this.parent_comment.replies || !Array.isArray(this.parent_comment.replies)) {
            this.parent_comment.replies = [];
          }
          this.parent_comment.replies.unshift(this.createComment(val));
          window.$bus.$emit("openSubComment", {id: this.parent_comment.id});
        }else {
          window.$bus.$emit("refreshComment", this.item);
        }
        this.resetReplay();
      })
    }
  }
};
</script>

<template>
  <div class="comment-panel">
    <van-action-sheet v-model="show" :duration="0.1" :title="`${totalCount}条评论`" @closed="onClosed">
      <div class="h-400 content">
        <div v-if="commentList && commentList.length > 0" class="px-4 min-h-full">
          <CommentList ref="myCommentList" :can-replay="true" :comment-list="commentList" @reply="onReply"></CommentList>
        </div>
        <div v-else class="h-full">
          <van-empty description="暂无评论" />
        </div>
        <CommentInput ref="myInput" :parent-comment="parent_comment" @send="onSendMessage" @close-reply="resetReplay"></CommentInput>
      </div>
    </van-action-sheet>
  </div>
</template>

<style>

</style>
